import * as AvatarPrimitive from "@radix-ui/react-avatar";
import styled from "styled-components";

export const Image = styled(AvatarPrimitive.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default Image;
